import { useAtomValue } from "jotai";
import { loadable } from "jotai/utils";

import { $userById } from "../../internal/users/user.atom";

export const useUserById = (userId: string) => {
	const loadableUser = useAtomValue(loadable($userById(userId)));
	return {
		user: loadableUser.state === "hasData" ? loadableUser.data : null,
		isLoading: loadableUser.state === "loading",
		error: loadableUser.state === "hasError" ? loadableUser.error : null,
	};
};
